import { Box } from "@mui/material";
import LiveVehicleStatusCard from "./LiveVehicleStatusCard";
import TotalVehiclesCard from "./TotalVehiclesCard";
import FleetMetricsCard from "./FleetMetricsCard";
import { useEffect, useState } from "react";
import { getSummaryStats } from "../../Api/FleetOverviewApi";
import { useBaseEntityInfo } from "../../Hooks/usePagesContent";

const StatsSection = ({ globalFilters }) => {
    const [stats, setStats] = useState({});
    const [loading, setLoading] = useState(false);

    const fetchStats = async () => {
        setLoading(true);
        const statsResponse = await getSummaryStats(globalFilters);
        setStats(statsResponse?.response?.data?.stats || {});
        setLoading(false);
    }

    useEffect(() => {
        if (Object.keys(globalFilters).length > 0) {
            fetchStats();
        };
    }, [globalFilters])

    return (
        // One row: Total Vehicles and Fleet Metrics take their content width, Live Vehicle Status gets the rest.
        <Box sx={{ display: 'flex', gap: 2 }}>
            {/* minWidth = the loaded tile's measured width, so loading / no-data states don't resize the row. */}
            <Box sx={{ flex: '0 1 auto', maxWidth: '40%', minWidth: 'min(440px, 40%)', display: 'flex' }}>
                <TotalVehiclesCard stats={stats} globalFilters={globalFilters} loading={loading} />
            </Box>
            <Box sx={{ flex: '1 1 0', minWidth: 0, display: 'flex' }}>
                <LiveVehicleStatusCard stats={stats} globalFilters={globalFilters} loading={loading} />
            </Box>
            <Box sx={{ flex: '0 0 auto', display: 'flex' }}>
                <FleetMetricsCard stats={stats} loading={loading} />
            </Box>
        </Box>
    )
}

export default StatsSection;
